import { DocumentNode, gql } from '@apollo/client';
import { Box, Divider, HStack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { EModItemResolutionState } from '@/client/legacy-shared-modules/moderation-item/moderationType';
import { AlertCircleIcon } from '@/imports/ui/chakra/feather';

import { ModerationHeader_PostFragment } from './graphql-types/ModerationHeader_PostFragment';

import { PendingModerationState } from './components/PendingModerationState';
import { RejectedModerationState } from './components/RejectedModerationState';

const POST_FRAGMENT = gql`
  fragment ModerationHeader_PostFragment on PostV2 {
    _id
    moderationItem {
      _id
      resolutionState
    }
    ... on AnswerV2 {
      _id
      questionPost {
        _id
        moderationItem {
          _id
          resolutionState
        }
      }
    }
    ...PendingModerationState_PostFragment
  }
  ${PendingModerationState.postFragment}
`;

export const ModerationHeader: React.FC<{
  post: ModerationHeader_PostFragment;
  isAnswerHeader: boolean;
}> & {
  postFragment: DocumentNode;
} = ({ post, isAnswerHeader }) => {
  const moderationState = post.moderationItem?.resolutionState;

  return (
    <Box px="4" pt="4">
      {post.__typename === 'AnswerV2' && !isAnswerHeader ? (
        <HStack alignItems="center">
          <>
            <AlertCircleIcon color="yellow.500" />
            <Text textStyle="compact" as="span" flexGrow="1">
              The original question is pending moderation
            </Text>
          </>
        </HStack>
      ) : (
        <HStack alignItems="center">
          {moderationState === EModItemResolutionState.PENDING && (
            <PendingModerationState post={post} />
          )}
          {moderationState === EModItemResolutionState.REJECTED && (
            <RejectedModerationState />
          )}
        </HStack>
      )}
      <Divider pt="4" />
    </Box>
  );
};

ModerationHeader.postFragment = POST_FRAGMENT;
